// extracted by mini-css-extract-plugin
module.exports = {"desktop_only":"(min-width: 1024px)","cell":"cell-1PZIX","input":"input-nw_bX","location__value":"location__value-3Qs-g"};